import { useEffect, useState } from "react";
import Slider from "react-slick";
import Box from "@mui/material/Box";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

interface UberTypeOfCarTypes {
  handleUberTypeOfCar: (vehicle: any) => void;
  isDisabled: boolean;
}

export default function UberTypeOfCars({ handleUberTypeOfCar, isDisabled }: UberTypeOfCarTypes) {
  const [initialSlide, setInitialSlide] = useState(-1); // Should be 0 or bigger in order to show Slider

  const { t } = useTranslation();

  // states
  const uberVehicle = useSelector((state: any) => state.uber.uberVehicle);
  const selectedUberCar = useSelector((state: any) => state.uber.selectedUberCar);

  useEffect(() => {
    setInitialSlide(0);
  }, []);

  const totalVehicles = uberVehicle.length;

  const maxSlidesDesktop = 5;
  const maxSlidesMobile = 2;

  const slidesToShowDesktop = Math.min(maxSlidesDesktop, totalVehicles);
  const slidesToScrollDesktop = 1;

  const slidesToShowMobile = Math.min(maxSlidesMobile, totalVehicles);
  const slidesToScrollMobile = 1;

  const settings = {
    arrows: totalVehicles > slidesToShowDesktop,
    dots: totalVehicles > slidesToShowDesktop,
    infinite: false, // Prevents repeating
    speed: 500,
    slidesToShow: slidesToShowDesktop,
    slidesToScroll: slidesToScrollDesktop,
    swipeToSlide: true,
    vertical: false,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: slidesToShowMobile,
          slidesToScroll: slidesToScrollMobile,
          arrows: totalVehicles > slidesToShowMobile,
          dots: totalVehicles > slidesToShowMobile,
          infinite: false // Also disables loop on mobile
        }
      }
    ]
  };
  return (
    <Box mt={{ xs: 3, sm: 2 }} mb={1}>
      <Box ml={{ xs: 2, sm: 1 }} mr={{ xs: 2, sm: 1 }} sx={isDisabled ? { opacity: 0.5, pointerEvents: "none" } : {}}>
        {initialSlide >= 0 && uberVehicle?.length > 0 && (
          <Slider {...settings} initialSlide={initialSlide}>
            {uberVehicle?.length > 0 &&
              uberVehicle?.map((offer: any) => (
                <>
                  <Box
                    key={offer?.category}
                    className={`uber-quick-selection-item ${
                      offer?.category === selectedUberCar?.category
                        ? "uber-quick-selection-item__active"
                        : !offer?.product_id
                        ? "uber-quick-selection-item__disabled"
                        : ""
                    }`}
                    onClick={() => handleUberTypeOfCar(offer)}
                  >
                    <Box className="uber-quick-selection-item__label"> {offer?.label}</Box>
                    {offer?.capacity && (
                      <Box className="uber-quick-selection-item__sublabel">
                        {t("transport.uberCapacityTitle")} {`1-${offer?.capacity}`}
                      </Box>
                    )}
                  </Box>
                </>
              ))}
          </Slider>
        )}
      </Box>
    </Box>
  );
}
